// ICF Articles Reducer
import * as types from '../constants/ActionTypes';

const initialState = {
  icfLoading: false,
  icfGuidesResponse: [],
  icfGuidesError: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.REQUEST_ICF_GUIDES:
      return { icfLoading: true };
    case types.RECEIVE_ICF_GUIDES_RESPONSE:
      return {
        icfLoading: false,
        icfGuidesResponse: action.payload.icf_list,
        icfGuidesError: false,
      };
    case types.RECEIVE_ICF_GUIDES_ERROR:
      return {
        icfLoading: false,
        icfGuidesResponse: [],
        icfGuidesError: true,
      };
    default:
      return state;
  }
}
